import { DataTable } from "@/components/tool-kit/primitives";
import { WIDGET_H3 } from "@/components/tool-kit/styles";
import type { IDEAL_GAS_LAW_CALCULATOR_STRINGS } from "@/components/tools/ideal-gas-law-calculator";
import { useToolNumber } from "@/components/tools/tool-ui";
import {
  GAS_CONDITIONS,
  gasConstantRows,
  molarVolumeLitres,
} from "@/lib/tool-kit/chem-physical/gas";
import { formatPlain, formatSig } from "@/lib/tool-kit/chemistry/format";

type Strings = typeof IDEAL_GAS_LAW_CALCULATOR_STRINGS;

const R_SIG = 10;
const VM_SIG = 5;

const CONDITION_LABELS = {
  stp: "conditionStp",
  stpLegacy: "conditionStpLegacy",
  satp: "conditionSatp",
  satpLegacy: "conditionSatpLegacy",
} as const;

export function GasReference({ strings }: { strings: Strings }) {
  const fmt = useToolNumber();
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h3 className={WIDGET_H3}>{strings.rTableHeading}</h3>
        <p className="text-muted-foreground text-sm">{strings.rTableNote}</p>
        <DataTable
          head={[strings.columnUnit, strings.columnValue]}
          rows={gasConstantRows().map((row) => [
            row.unit,
            formatSig(fmt, row.value, R_SIG),
          ])}
        />
      </div>
      <div className="space-y-3">
        <h3 className={WIDGET_H3}>{strings.vmTableHeading}</h3>
        <p className="text-muted-foreground text-sm">{strings.vmTableNote}</p>
        <DataTable
          head={[
            strings.columnCondition,
            strings.columnTemperature,
            strings.columnPressure,
            strings.columnMolarVolume,
          ]}
          rows={GAS_CONDITIONS.map((c) => [
            strings[CONDITION_LABELS[c.id]],
            `${formatPlain(fmt, c.t)} K`,
            `${formatPlain(fmt, c.p / 1000)} kPa`,
            formatSig(fmt, molarVolumeLitres(c.t, c.p), VM_SIG),
          ])}
        />
      </div>
    </div>
  );
}
